import React from 'react';
import './Image.scss';

export type ImageProps = {
  id: string;
  source: string;
  height?: string | number;
  width?: string | number;
  altText: string;
  overlayText?: string | React.ReactNode;
};

export const Image = ({
  id,
  source,
  height,
  width,
  altText,
  overlayText
}: ImageProps): JSX.Element => {
  return (
    <div id={id} className='image-widget'>
      <img
        className='image-widget-img'
        src={source}
        height={height}
        width={width}
        alt={altText}
      />
      {overlayText && <div className='image-widget-text'>{overlayText}</div>}
    </div>
  );
};

export default Image;
